import {
  createBlock,
  mergeBlock,
  NodeUtils,
  t,
} from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardSocialElement,
  StandardSocialItemElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { Social } from "@easy-email-pro-core/components/Elements";
import { omit } from "lodash";

import { Social as SourceElement } from "../../basic/Social";
import { BlockRenderer } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<StandardSocialElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {
      spacing: "8px",
    },
    data: {},
  });

export const StandardSocial = createBlock<StandardSocialElement>({
  get name() {
    return t("Social");
  },
  defaultData,
  type: StandardType.STANDARD_SOCIAL,
  create: (payload) => {
    const defaultData: StandardSocialElement = {
      type: StandardType.STANDARD_SOCIAL,
      data: {},
      attributes: {
        spacing: "8px",
        "icon-size": "30px",
      },
      children: [
        {
          data: {},
          type: "standard-social-element",
          children: [
            {
              text: "",
            },
          ],
          attributes: {
            src: "https://cdn.shopify.com/s/files/1/0863/8971/9346/files/psyz-f1z-ryy95lv2rh7g_image.png",
            href: "",
            "padding-left": "0px",
            "padding-right": "0px",
            "padding-top": "0px",
            "padding-bottom": "0px",
          },
        },
        {
          data: {},
          type: "standard-social-element",
          children: [
            {
              text: "",
            },
          ],
          attributes: {
            src: "https://cdn.shopify.com/s/files/1/0863/8971/9346/files/rxxjzpus7vy2cxi0vp6hr_image.png",
            href: "",
            "padding-left": "8px",
            "padding-right": "0px",
            "padding-top": "0px",
            "padding-bottom": "0px",
          },
        },
        {
          data: {},
          type: "standard-social-element",
          children: [
            {
              text: "",
            },
          ],
          attributes: {
            src: "https://cdn.shopify.com/s/files/1/0863/8971/9346/files/obdwqmxv5cljc16-ebnja_image.png",
            href: "",
            "padding-left": "8px",
            "padding-right": "0px",
            "padding-top": "0px",
            "padding-bottom": "0px",
          },
        },
      ],
    };

    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.SOCIAL,
  render(params) {
    const { node, idx } = params;
    const { ...attributes } = node.attributes;

    const spacing = params.node.attributes.spacing;
    return (
      <Social
        idx={params.idx}
        {...omit(attributes, ["spacing"])}
        data={node.data}
      >
        {node.children.map((child, index) => {
          if (!NodeUtils.isElement(child)) return null;

          const attrs = {
            ...child.attributes,
            "padding-left": "0px",
            "padding-right": "0px",
            "padding-top": "0px",
            "padding-bottom": "0px",
          } as StandardSocialItemElement["attributes"];

          if (params.node.attributes.mode === "horizontal") {
            if (index !== 0) {
              attrs["padding-left"] = spacing;
            }
          }

          if (params.node.attributes.mode === "vertical") {
            if (index !== 0) {
              attrs["padding-top"] = spacing;
            }
          }

          return (
            <BlockRenderer
              {...params}
              idx={NodeUtils.getChildIdx(NodeUtils.getPageIdx(), index)}
              key={index}
              node={{
                ...child,
                attributes: attrs as any,
              }}
            />
          );
        })}
      </Social>
    );
  },
});
